
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const HeroSection = () => {
  return (
    <section className="bg-gradient-to-r from-chapterly-purple to-chapterly-light-purple py-12 md:py-24">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 text-white mb-8 md:mb-0 md:pr-10">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
              Read stories, one chapter at a time
            </h1>
            <p className="text-base md:text-xl mb-6 md:mb-8">
              Discover captivating stories published episode by episode. Follow authors as they create, share your thoughts, and connect with other readers.
            </p>
            <div className="flex flex-wrap gap-3 md:gap-4">
              <Button 
                size="lg" 
                className="bg-white text-chapterly-purple hover:bg-gray-100 font-medium w-full sm:w-auto"
                asChild
              >
                <Link to="/browse">Start Reading</Link>
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="bg-transparent border-white text-white hover:bg-white hover:text-chapterly-purple font-medium w-full sm:w-auto"
                asChild
              >
                <Link to="/write">Start Writing</Link>
              </Button>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center relative">
            <img
              src="https://images.unsplash.com/photo-1550399105-c4db5fb85c18?auto=format&fit=crop&w=600&q=70&fm=webp"
              srcSet={[
                'https://images.unsplash.com/photo-1550399105-c4db5fb85c18?auto=format&fit=crop&w=320&q=70&fm=webp 320w',
                'https://images.unsplash.com/photo-1550399105-c4db5fb85c18?auto=format&fit=crop&w=600&q=70&fm=webp 600w',
                'https://images.unsplash.com/photo-1550399105-c4db5fb85c18?auto=format&fit=crop&w=900&q=70&fm=webp 900w',
              ].join(', ')}
              sizes="(max-width: 768px) 90vw, 448px"
              alt="Collection of colorful book covers"
              className="w-full max-w-md rounded-lg shadow-xl"
              loading="eager"
              fetchPriority="high"
              decoding="async"
              width="600"
              height="450"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
